/*
 * Jira Ticket:
 * Created Date: Thu, 11th Jun 2020, 10:23:01 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useEffect, useState } from 'react';
import {
  Datagrid,
  List,
  TextField,
  FunctionField,
  useDataProvider,
  ExportButton,
  downloadCSV
} from 'react-admin';
import {
  Tooltip,
} from '@material-ui/core';
import { Pagination } from '../../Components';
import { format, set } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAltExclamation } from '@fortawesome/pro-solid-svg-icons';
import FeedbackFilters from './filters';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { PieChart } from 'react-minimal-pie-chart';
import jsonExport from 'jsonexport/dist';
import { Dialog, DialogTitle } from '@material-ui/core';


const TemplateList = props => {

  const [percentage, setPercentage] = useState(0)
  const [average, setAverage] = useState(0)
  const [chartData, setChartData] = useState([])

  const [data, setData] = useState([]);
  const dataProvider = useDataProvider();

  const [showDialog, setShowDialog] = useState(false);

  const [currentFeedback, setCurrentFeedback] = useState('')

  const handleClick = (e) => {
    setShowDialog(true);
    setCurrentFeedback(e.feedbackContents)
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleFilterTringger = (filter) => {
    dataProvider.getList('feedback', { pagination: { page: 1, perPage: 1000 }, filter: filter }).then(({ data }) => {
      fetchData(data);
    });
  }

  useEffect(() => {
    dataProvider.getList('feedback', { pagination: { page: 1, perPage: 1000 } }).then(({ data }) => {
      fetchData(data);
    });
  }, [data]);

  const fetchData = (data) => {

    var oneStar = 0;
    var twoStar = 0;
    var threeStar = 0;
    var fourStar = 0;
    var fiveStar = 0;
    var total = 0;

    data.forEach(value => {
      if (value.starNumbers != 0) {
        total++;
      }
      switch (value.starNumbers) {
        case 1:
          oneStar++;
          break;
        case 2:
          twoStar++;
          break;
        case 3:
          threeStar++;
          break;
        case 4:
          fourStar++;
          break;
        case 5:
          fiveStar++;
          break;
        default:
          break;
      }
    });

    var average = 0;
    var percentage = 0;

    if (total === 0) {
      setAverage(0);
      setPercentage(0);
    } else {
      average = (oneStar + (twoStar * 2) + (threeStar * 3) + (fourStar * 4) + (fiveStar * 5)) / total;
      average = average.toFixed(2);
      setAverage(average);

      percentage = (average / 5) * 100;
      setPercentage(percentage);
    }

    setChartData([]);
    var chartData = [];
    if (oneStar > 0) {
      chartData.push({ title: 'One Star', value: oneStar, color: '#E8ADAD' })
    }
    if (twoStar > 0) {
      chartData.push({ title: 'Two Star', value: twoStar, color: '#DE9696' })
    }
    if (threeStar > 0) {
      chartData.push({ title: 'Three Star', value: threeStar, color: '#D27272' })
    }
    if (fourStar > 0) {
      chartData.push({ title: 'Four Star', value: fourStar, color: '#CA4242' })
    }
    if (fiveStar > 0) {
      chartData.push({ title: 'Five Star', value: fiveStar, color: '#BB1616' })
    }

    setChartData(chartData);
  }

  const fanstyle = { float: 'right', marginTop: '5px', width: '50px', marginLeft: '10px' }

  const exporter = feedback => {
    const feedbackForExport = feedback.map(feedback => {
      return {
        Name: feedback.sleuthName,
        Director: feedback.event.eventDirector.firstName + ' ' + feedback.event.eventDirector.lastName,
        Location: feedback.event.eventLocation.name,
        'Event name': feedback.event.name,
        Date: format(new Date(feedback.updatedAt), 'yyyy-MM-dd'),
        Rating: feedback.starNumbers,
        Feedback: feedback.feedbackContents
      };
    });
    jsonExport(feedbackForExport, {
      headers: ['Name', 'Director', 'Location', 'Event name', 'Date', 'Rating', 'Feedback'] // order fields in the export
    }, (err, csv) => {
      downloadCSV(csv, 'feedback-report-' + format(new Date(), 'yyyy-MM-dd')); // download as 'posts.csv` file
    });
  };


  return <>

    <div className='container MuiPaper-elevation1 MuiPaper-rounded' style={{ backgroundColor: 'white', marginBottom: '20px' }}>

      <div style={{ display: 'inline-block' }}>
        <h3 className='MuiTableCell-sizeSmall' style={{ float: 'left', paddingRight: '5px' }}>
          Analysis
        </h3>

        <div style={{ marginTop: '20px', fontSize: '14px', float: 'left', width: '10px' }}>
          <Tooltip title={'This report provides the average star rating given to all events in the app.'} placement='left-end' classes={{ tooltip: 'noMaxWidth' }}>
            <div>
              <FontAwesomeIcon icon={faExclamationCircle} />
            </div>
          </Tooltip>

        </div>

        <div style={{ width: '300px', padding: '10px', margin: '10px', color: 'white' }}>
          <PieChart
            // segmentsShift={0.5}
            radius={40}
            label={({ dataEntry }) => dataEntry.value}
            data={chartData}
            labelStyle={{
              color: 'white !important',
              fontSize: '7px',
              fill: 'white',
            }}
            background='#bfbfbf'
            animate={true}
          />
        </div>
      </div>

      <div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: '135px' }}>

        <svg width="50" height="35" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 7L21.0211 13C22.3263 9.10034 22.3263 4.89966 21.0211 1L2 7Z" fill="#BB1616" stroke="white" />
        </svg>

        <div style={fanstyle}>
          5 star
        </div>
        <br />

        <svg width="50" height="35" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 7L21.0211 13C22.3263 9.10034 22.3263 4.89966 21.0211 1L2 7Z" fill="#CA4242" stroke="white" />
        </svg>

        <div style={fanstyle}>
          4 stars
        </div>
        <br />


        <svg width="50" height="35" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 7L21.0211 13C22.3263 9.10034 22.3263 4.89966 21.0211 1L2 7Z" fill="#D27272" stroke="white" />
        </svg>

        <div style={fanstyle}>
          3 stars
        </div>
        <br />

        <svg width="50" height="35" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 7L21.0211 13C22.3263 9.10034 22.3263 4.89966 21.0211 1L2 7Z" fill="#DE9696" stroke="white" />
        </svg>

        <div style={fanstyle}>
          2 stars
        </div>
        <br />

        <svg width="50" height="35" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 7L21.0211 13C22.3263 9.10034 22.3263 4.89966 21.0211 1L2 7Z" fill="#E8ADAD" stroke="white" />
        </svg>

        <div style={fanstyle}>
          1 stars
        </div>
      </div>

      <div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: '200px', marginLeft: '100px', width: '30vw' }}>
        <div style={{ display: 'inline-block', width: percentage + '%', height: '50px', backgroundColor: '#BB1616' }}>
          <div style={{ color: 'white', textAlign: 'center', fontSize: '30px', paddingTop: '5px' }}>
            {average}
          </div>
        </div>
        <div style={{ display: 'inline-block', width: (100 - percentage) + '%', height: '50px', backgroundColor: '#D9D9D9' }}>
          <div style={{ color: 'white', textAlign: 'center', fontSize: '30px', paddingTop: '5px' }}>
            &nbsp;
          </div>
        </div>
      </div>

    </div>


    <List
      bulkActionButtons={false}
      pagination={<Pagination />}
      perPage={50}
      filters={<FeedbackFilters filtertrigger={handleFilterTringger} />}
      {...props}
      actions={
        <ExportButton style={{ marginTop: '15px', marginRight: '10px', paddingTop: '7px' }}></ExportButton>
      }
      exporter={exporter}
      sort={{ field: 'updatedAt', order: 'DESC' }}
    >
      <Datagrid>
        <TextField
          source="sleuthName"
          label="Name"
          sortable={false}
        />
        <FunctionField
          source="event.eventDirector"
          label="Event director"
          render={(record) => {
            if (record.event.eventDirector) {
              return record.event.eventDirector.firstName + ' ' + record.event.eventDirector.lastName
            } else {
              return ''
            }
          }
          }
        />
        <TextField
          source="event.eventLocation.name"
          label="Location"
          sortable={false}
        />
        <TextField
          source="event.name"
          label="Event name"
          sortable={false}
        />
        <FunctionField
          source="updatedAt"
          label="Date"
          sortable={true}
          sortBy='updatedAt'
          sortByOrder="DESC"
          render={(record) => {
            var date = new Date(record.updatedAt)
            date = format(date, 'yyyy-MM-dd')
            return date
          }
          }
        />
        <TextField
          source="starNumbers"
          label="Rating (*)"
          sortable={false}
        />
        <FunctionField
          source="feedbackContents"
          label="Feedback"
          sortable={false}
          render={(record) => {
            let content = record.feedbackContents ? record.feedbackContents : '';
            return (
              content ? <Tooltip title={content.length < 10 ? content : content.substring(0, 10) + '...'} placement='right-end'>
                <div onClick={() => handleClick(record)}>
                  <FontAwesomeIcon icon={faCommentAltExclamation} />
                </div>
              </Tooltip> : <div style={{ width: '20px', height: '20px' }}></div>
            )
          }
          }
        />
      </Datagrid>
    </List>

    <Dialog open={showDialog} fullWidth
      onClose={handleCloseClick}
      aria-label={`Feedback detail`}
    >
      <DialogTitle id="alert-dialog-title">
        Feedback detail
      </DialogTitle>
      <div style={{ padding: '16px 24px' }}>
        {currentFeedback}
      </div>
    </Dialog>

  </>

};

export default TemplateList;
